import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { InfoBanner } from '@gov-nx/ui/web';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';

export const Table = () => {
	const { documents, code } = useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<div>
			{documents?.seznam && documents.seznam.length > 0 ? (
				<TableHead />
			) : (
				<InfoBanner
					headline={tsn('stav.chyba.zatim-tu-nic-nemame')}
					text={tsn('stav.chyba.nenasli-jsme-zadne-soubory')}
				/>
			)}
			<ul className="gov-list--plain">
				{documents?.seznam?.map((document) => (
					<TableRow
						key={document.dokumentId}
						document={document}
					/>
				))}
			</ul>
		</div>
	);
};
